import React, { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import "./PlannedDateWindow.scss"
import NudgePage from "../../containers/Nudge/Nudge"
import {
  PLAN_DINNER,
  ORDER_DELIVERED_BUTTON,
  ORDER_INFORMATION_BANNER_USER,
  RATE_YOUR_EXPERIENCE,
  SUBMIT_BUTTON,
  CANCEL,
  ORDER_INFORMATION_BANNER_SUB_HEADING,
  COMBINED_ORDER_INFORMATION,
  PARTNER_ORDER_NUMBER_BANNER,
  BOND_OVER_MEMORIES,
  MEET_CONCIERGE,
  NEXT_MODAL_TEXT,
  CONTINUE_TEXT,
  DEFAULT_SPACE_NAME,
} from "../../constants/messages"
import _ from "../../utils/lodashUtils"
import ChooseRestaurantPage from "../../containers/ChooseRestaurantPage/ChooseRestaurantPage"
import { invitePartnerToChat } from "../../redux/actionCreators/invitePeople"
import { FirebaseService } from "../../firebase"
import { FIREBASE_STATE_KEYS } from "../../firebase"
import { SCREENS } from "../../constants/screens"
import PlanDateMaleRight from "../../assets/images/PlanDateMaleRight.svg"
import PlanDateFemaleRight from "../../assets/images/PlanDateFemaleRight.svg"
import PlanDateMaleLeft from "../../assets/images/PlanDateMaleLeft.svg"
import PlanDateFemaleLeft from "../../assets/images/PlanDateFemaleLeft.svg"
import { setReadyModal } from "../../redux/actionCreators/planDinnner"
import API from "../../axiosConfig/axiosConfig"
import { ENDPOINTS } from "../../constants/apiEndPoints"
import { FirebaseContext } from "../../firebase"
import { Button, CustomModal, TextTag as Text } from "../../atoms"
import GetReadyPage from "../GetReady/GetReady"
import { getPartnerNameorNickName } from "../../utils/helpers"
import DateWaitPage from "../../containers/DateWaitPage/DateWaitPage"
import { DRAFT_ADDRESS_MODES, CUSTOM_EVENTS } from "../../constants/commons"
import { emitter } from "../../utils/emitter"
import { Rate } from "antd"
import BlockingModal from "../BlockingModal/BlockingModal"

const PlannedDateWindow = props => {
  const { userState, partnerState, dateState } = React.useContext(
    FirebaseContext
  )
  const firebasePartnerName = getPartnerNameorNickName(
    partnerState,
    props.partnerDetails
  )
  const getReady = _.get(userState, "getReady", true)
  const planADate = _.get(props.date, "planADate", false)
  const [order, setOrder] = useState(null)
  const [rating, setRating] = useState(0)
  const [modal, toggleModal] = React.useState(false)
  const firebaseDefaultPath = FirebaseService.getDefaultPath()
  const { showReadyModal, setReadyModal } = props
  useEffect(() => {
    async function fetchData() {
      //to fetch the order delivered banner
      const latestOrder = await API.get(ENDPOINTS.GET_LATEST_ORDER)
      setOrder(latestOrder.data)
    }

    fetchData()
  }, [])
  const setBackModal = value => () => {
    setReadyModal(value)
  }

  React.useEffect(() => {
    const showReadyModalListener = emitter.addListener(
      CUSTOM_EVENTS.SHOW_READY_PAGE_MODAL,
      setBackModal(true)
    )
    const hideReadyModalListener = emitter.addListener(
      CUSTOM_EVENTS.HIDE_READY_PAGE_MODAL,
      setBackModal(false)
    )
    return () => {
      showReadyModalListener.remove()
      hideReadyModalListener.remove()
    }
  }, [])

  const userGender = _.get(userState, "userDetails.gender")
  const partnerGender = _.get(partnerState, "userDetails.gender")
  const chatSpaceName =
    _.get(
      dateState,
      "chatSpaceName",
      _.get(props.partners, "chat_space_name", DEFAULT_SPACE_NAME)
    ) || DEFAULT_SPACE_NAME
  const partnerAddress = _.get(
    partnerState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.ADDRESS}`
  )
  let nickName = _.get(props.invite, "nickName")
  const userUuid = _.get(props, "user.uuid")
  const backToPlanDinner = _.get(userState, "backToPlanning")
  const isCombinedOrder = _.get(order, "user_order.combined_order")
    ? _.get(order, "user_order.combined_order")
    : _.get(order, "partner_order.combined_order")
    ? _.get(order, "partner_order.combined_order")
    : false
  let combinedOrderId = 0
  let merchantName = ""
  let orderDate = ""
  const userOrder = _.get(order, "user_order", null)

  const findWhoPaid = () => {
    let paidby = ""
    if (
      _.get(order, "user_order.paid_by.user") &&
      !_.get(order, "user_order.feedback_received")
    ) {
      paidby = _.get(order, "user_order.paid_by.user")
    } else {
      paidby = _.get(order, "partner_order.paid_by.user")
    }
    return paidby
  }
  const paidByUser = findWhoPaid()
  const paidByStatus = _.get(order, "user_order.paid_by.status")
    ? _.get(order, "user_order.paid_by.status")
    : _.get(order, "partner_order.paid_by.status")
    ? _.get(order, "partner_order.paid_by.status")
    : null

  const gotoBondOverMemories = async () => {
    await FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.BOND_OVER_MEMORIES,
      },
      `${firebaseDefaultPath}${userUuid}`
    )
    props.history.push("/bond-over-memories")
  }

  const goToMeetConcierge = async () => {
    await FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.MEET_CONCIERGE,
      },
      `${firebaseDefaultPath}${userUuid}`
    )
    props.history.push("/meet-concierge")
  }

  if ((!planADate && !backToPlanDinner) || getReady === "PLAN_DATE") {
    if (isCombinedOrder) {
      combinedOrderId =
        paidByUser === props.user.username
          ? _.get(order, "user_order.order_id")
          : _.get(order, "partner_order.order_id")
      merchantName =
        paidByUser === props.user.username
          ? _.get(order, "user_order.merchant_details.merchant", "")
          : _.get(order, "partner_order.merchant_details.merchant", "")
      orderDate =
        paidByUser === props.user.username
          ? _.get(order, "user_order.created_on", "")
          : _.get(order, "partner_order.created_on", "")
    }
    FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.PLAN_NEW_DATE,
      },
      `${firebaseDefaultPath}${userUuid}`
    )
    let showOrderConfirmBanner = false
    if (order) {
      if (order.user_order) {
        showOrderConfirmBanner = !_.get(
          order,
          "user_order.feedback_received",
          true
        )
      } else if (order.partner_order && order.partner_order.combined_order) {
        showOrderConfirmBanner = !_.get(
          order,
          "partner_order.feedback_received",
          true
        )
      }
    }

    return (
      <div id="PlannedDateWindow">
        <CustomModal
          title={RATE_YOUR_EXPERIENCE}
          visible={modal}
          keyboard={false}
          onCancel={() => toggleModal(false)}
          footer={[
            <Button
              type="primary"
              key="save"
              onClick={() => {
                async function updateRating() {
                  await API.post(ENDPOINTS.SAVE_RATING, {
                    order_id: _.get(order, "user_order")
                      ? _.get(order, "user_order.order_id")
                      : _.get(order, "partner_order") &&
                        _.get(order, "partner_order.combined_order")
                      ? _.get(order, "partner_order.order_id")
                      : null,
                    rating: rating,
                    is_partner_order: _.get(order, "user_order")
                      ? false
                      : _.get(order, "partner_order") &&
                        _.get(order, "partner_order.combined_order")
                      ? true
                      : false,
                  })
                }
                updateRating()
                setOrder(null)
                toggleModal(false)
              }}
            >
              {SUBMIT_BUTTON}
            </Button>,
            <Button
              btnType="bordered"
              key="cancel"
              onClick={() => {
                setRating(0)
                toggleModal(false)
              }}
            >
              {CANCEL}
            </Button>,
          ]}
        >
          <div>
            <Rate
              value={rating}
              onChange={value => {
                setRating(value)
              }}
            />
          </div>
        </CustomModal>
        {showOrderConfirmBanner && (
          <div className="orderConfirmEmailContainer">
            <div className="order-confirm-banner-text">
              {userOrder !== null && !isCombinedOrder && (
                <div className="banner-heading">
                  {ORDER_INFORMATION_BANNER_USER(order)}
                </div>
              )}
              {isCombinedOrder && (
                <div className="banner-sub-heading">
                  <Text>
                    {COMBINED_ORDER_INFORMATION(
                      firebasePartnerName,
                      combinedOrderId,
                      merchantName,
                      orderDate
                    )}
                  </Text>
                </div>
              )}
              {!isCombinedOrder &&
                paidByStatus !== "SELF" &&
                paidByUser === _.get(props, "user.username") && (
                  <div className="banner-sub-heading">
                    <Text>{PARTNER_ORDER_NUMBER_BANNER(order)}</Text>
                  </div>
                )}
              <div className="banner-sub-heading">
                <Text>
                  {ORDER_INFORMATION_BANNER_SUB_HEADING(
                    paidByUser === _.get(props, "user.username")
                      ? "You"
                      : firebasePartnerName
                  )}
                </Text>
              </div>
            </div>
            <Button
              btnType="small"
              onClick={() => {
                toggleModal(true)
              }}
            >
              {ORDER_DELIVERED_BUTTON}
            </Button>
          </div>
        )}
        <div className="planDinnerContainer">
          <div className="planDinner">
            <div>
              <img
                className="planDinnerImg1"
                src={
                  userGender === "FEMALE"
                    ? PlanDateFemaleLeft
                    : PlanDateMaleLeft
                }
                alt="PlanDinner"
              />
            </div>
            <div>
              <Button
                btnType="primary"
                btnSize="large"
                shape="round"
                onClick={goToMeetConcierge}
              >
                {MEET_CONCIERGE}
              </Button>
              <Button
                onClick={async () => {
                  emitter.fire(
                    CUSTOM_EVENTS.HIDE_PARTNER_BACK_TO_PLAN_A_DATE_MODAL,
                    []
                  )
                  await FirebaseService.patch(
                    {
                      [`${props.user.uuid}/${FIREBASE_STATE_KEYS.GET_READY}`]: true,
                      [`${props.partnerDetails.uuid}/${FIREBASE_STATE_KEYS.GET_READY}`]: true,
                      [FIREBASE_STATE_KEYS.PLAN_A_DATE]: true,
                    },
                    firebaseDefaultPath
                  )
                }}
                btnType="primary"
                btnSize="large"
                shape="round"
              >
                {PLAN_DINNER}
              </Button>
              <Button
                btnType="primary"
                btnSize="large"
                shape="round"
                onClick={gotoBondOverMemories}
              >
                {BOND_OVER_MEMORIES}
              </Button>
            </div>
            <div>
              <img
                className="planDinnerImg2"
                src={
                  partnerGender === "FEMALE"
                    ? PlanDateFemaleRight
                    : PlanDateMaleRight
                }
                alt="PlanDinner"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Handle Location Scenarios
  const userAddress = _.get(userState, "userDetails.address")

  const userDraftAddress = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.DRAFT_ADDRESS}`
  )
  const partnerDraftAddress = _.get(
    partnerState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.DRAFT_ADDRESS}`
  )
  if (getReady && !userAddress) {
    FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.GET_READY,
      },
      `${firebaseDefaultPath}${userUuid}`
    )
    return (
      <React.Fragment>
        <GetReadyPage
          partnerName={firebasePartnerName || nickName}
          userUuid={userUuid}
          partners={props.partners}
        />
        <BlockingModal
          withOptions
          title={NEXT_MODAL_TEXT(chatSpaceName)}
          buttonText={CONTINUE_TEXT}
          blockingModalVisibility={showReadyModal}
          continueHandler={async () => {
            await FirebaseService.patch(
              {
                [FIREBASE_STATE_KEYS.GET_READY]: null,
              },
              `${firebaseDefaultPath}${userUuid}`
            )
            FirebaseService.setActiveRoute("/date/wait")
            props.history.push("/date/wait")
            setReadyModal(false)
          }}
          cancelHandler={() => setReadyModal(false)}
        />
      </React.Fragment>
    )
  } else if (
    _.get(userAddress, "user_address", "") === "" ||
    _.get(partnerAddress, "user_address", "") === ""
  ) {
    FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.ADDRESS_WAIT_SCREEN,
      },
      `${firebaseDefaultPath}${userUuid}`
    )
    props.history.push("/date/wait")
    return <DateWaitPage {...props} />
  }
  FirebaseService.patch(
    {
      [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.SELECT_RESTAURANT,
    },
    `${firebaseDefaultPath}${userUuid}`
  )
  FirebaseService.setActiveRoute("/choose-restaurant")
  props.history.push("/choose-restaurant")
  return <ChooseRestaurantPage {...props} />
}

const mapStateToProps = state => ({
  user: state.auth.user,
  partnerDetails: state.auth.partner,
  invite: state.invitePeople,
  partners: state.invitePeople.partnerDetails,
  planDinner: state.planDinner,
  showReadyModal: _.get(state, "loadingState.showReadyModal", false),
})

export default withRouter(
  connect(mapStateToProps, { invitePartnerToChat, setReadyModal })(
    PlannedDateWindow
  )
)
